import Image from '@/components/base/image'
import React from 'react'
import { WorksProps } from './type'

const UlupinarWorks: React.FunctionComponent<WorksProps> = ({
  title,
  desc,
  descImage,
}) => {
  return (
    <div className="ulupinar-works">
      <div className="ulupinar-works-info">
        <h3 className="ulupinar-works-info-title">{title}</h3>
        {desc && (
          <div
            className="ulupinar-works-info-desc"
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        )}
      </div>

      <div className="ulupinar-works-image">
        <figure>
          <Image className="full-image" {...descImage} alt="" />
        </figure>
      </div>
    </div>
  )
}

export default UlupinarWorks
